import { HourlyBarDatum } from "@/components/pages/dashboard/components/charts/DashboardHourlyBarChart";
import { SettlementBooking } from "@/components/pages/settlement/types/settlementBooking";

const TIME_SLOTS = [
  { label: "06:00", startHour: 0, endHour: 9 },
  { label: "09:00", startHour: 9, endHour: 12 },
  { label: "12:00", startHour: 12, endHour: 15 },
  { label: "15:00", startHour: 15, endHour: 18 },
  { label: "18:00", startHour: 18, endHour: 24 },
] as const;

export function buildHourlyChartData<T>(
  items: T[],
  getDate: (item: T) => Date,
  isPrimary: (item: T) => boolean,
  isSecondary: (item: T) => boolean,
): HourlyBarDatum[] {
  return TIME_SLOTS.map(({ label, startHour, endHour }) => {
    const slotItems = items.filter((item) => {
      const hour = getDate(item).getUTCHours();
      return hour >= startHour && hour < endHour;
    });
    return {
      label,
      primary: slotItems.filter(isPrimary).length,
      secondary: slotItems.filter(isSecondary).length,
    };
  });
}

export function buildHourlySettlementChartData(
  bookings: SettlementBooking[],
  getDate: (booking: SettlementBooking) => Date,
  isPrimary: (booking: SettlementBooking) => boolean,
  isSecondary: (booking: SettlementBooking) => boolean,
): HourlyBarDatum[] {
  return buildHourlyChartData(bookings, getDate, isPrimary, isSecondary);
}
